/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  OrgSpecAdminCreate,
  OrgSpecAdminDelete,
  OrgSpecAdminUpdate,
  OrgSpecOnAzure,
} from '../models/index';
import {
    OrgSpecAdminCreateFromJSON,
    OrgSpecAdminCreateToJSON,
    OrgSpecAdminDeleteFromJSON,
    OrgSpecAdminDeleteToJSON,
    OrgSpecAdminUpdateFromJSON,
    OrgSpecAdminUpdateToJSON,
    OrgSpecOnAzureFromJSON,
    OrgSpecOnAzureToJSON,
} from '../models/index';

export interface ApiOrgSpecAddPostRequest {
    orgSpecAdminCreate?: OrgSpecAdminCreate;
}

export interface ApiOrgSpecDeleteDeleteRequest {
    orgSpecAdminDelete?: OrgSpecAdminDelete;
}

export interface ApiOrgSpecGetAllByOrgCodeGetRequest {
    orgCode?: string;
}

export interface ApiOrgSpecGetByOrgCodeAndIdGetRequest {
    orgCode?: string;
    orgSpecAzureId?: string;
}

export interface ApiOrgSpecUpdatePutRequest {
    orgSpecAdminUpdate?: OrgSpecAdminUpdate;
}

/**
 * 
 */
export class OrgSpecApi extends runtime.BaseAPI {

    /**
     */
    async apiOrgSpecAddPostRaw(requestParameters: ApiOrgSpecAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrgSpecOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgSpec/Add`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrgSpecAdminCreateToJSON(requestParameters['orgSpecAdminCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrgSpecOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiOrgSpecAddPost(requestParameters: ApiOrgSpecAddPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrgSpecOnAzure> {
        const response = await this.apiOrgSpecAddPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrgSpecDeleteDeleteRaw(requestParameters: ApiOrgSpecDeleteDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgSpec/Delete`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: OrgSpecAdminDeleteToJSON(requestParameters['orgSpecAdminDelete']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrgSpecDeleteDelete(requestParameters: ApiOrgSpecDeleteDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiOrgSpecDeleteDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiOrgSpecGetAllByOrgCodeGetRaw(requestParameters: ApiOrgSpecGetAllByOrgCodeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OrgSpecOnAzure>>> {
        const queryParameters: any = {};

        if (requestParameters['orgCode'] != null) {
            queryParameters['org_code'] = requestParameters['orgCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgSpec/GetAllByOrgCode`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrgSpecOnAzureFromJSON));
    }

    /**
     */
    async apiOrgSpecGetAllByOrgCodeGet(requestParameters: ApiOrgSpecGetAllByOrgCodeGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OrgSpecOnAzure>> {
        const response = await this.apiOrgSpecGetAllByOrgCodeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrgSpecGetByOrgCodeAndIdGetRaw(requestParameters: ApiOrgSpecGetByOrgCodeAndIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrgSpecOnAzure>> {
        const queryParameters: any = {};

        if (requestParameters['orgCode'] != null) {
            queryParameters['org_code'] = requestParameters['orgCode'];
        }

        if (requestParameters['orgSpecAzureId'] != null) {
            queryParameters['org_spec_azure_id'] = requestParameters['orgSpecAzureId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgSpec/GetByOrgCodeAndId`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrgSpecOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiOrgSpecGetByOrgCodeAndIdGet(requestParameters: ApiOrgSpecGetByOrgCodeAndIdGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrgSpecOnAzure> {
        const response = await this.apiOrgSpecGetByOrgCodeAndIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrgSpecUpdatePutRaw(requestParameters: ApiOrgSpecUpdatePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgSpec/Update`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrgSpecAdminUpdateToJSON(requestParameters['orgSpecAdminUpdate']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrgSpecUpdatePut(requestParameters: ApiOrgSpecUpdatePutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiOrgSpecUpdatePutRaw(requestParameters, initOverrides);
    }

}
